import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RicorsoAnonimo } from '../../models/ricerca-anonima-dto';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-consultazione-anonima-list-ricorsi',
  templateUrl: './consultazione-anonima-list-ricorsi.component.html',
  styleUrls: ['./consultazione-anonima-list-ricorsi.component.css']
})
export class ConsultazioneAnonimaListRicorsiComponent implements OnChanges {
  @Input() ricorsi: RicorsoAnonimo[];
  currentRicorsi: RicorsoAnonimo[];
  resetCurrentPage: boolean = false;
  currentPage: number = 0;
  itemsPerPage: number = 10;

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (!!changes.ricorsi) {
      this.resetCurrentPage = true;
      this.currentPage = 0;
      this.setCurrentRicorsi();
    }
  }

  onRefresh(event: Pagination) {
    this.currentPage = event.getCurrentPage();
    this.itemsPerPage = event.getItemsPerPage();

    this.setCurrentRicorsi();
    this.resetCurrentPage = false;
  }

  setCurrentRicorsi() {
    this.currentRicorsi = this.ricorsi.slice(this.currentPage * this.itemsPerPage, (this.currentPage + 1) * this.itemsPerPage);
  }

  replaceNull (value) {
    return !!value && value != '' ? value : '-';
  }

}
